<template>
  <div v-if="care_vital_sign.care_has_vital_signs.length > 0">
    <p
      :class="[
        'm-0 text-thirteen upper-text',
        parseInt(item.description) >= 10 &&
          parseInt(item.description) <= 20 &&
          'color-green',
        parseInt(item.description) >= 21 &&
          parseInt(item.description) <= 34 &&
          'color-orange',
        (parseInt(item.description) < 10 || parseInt(item.description) > 34) &&
          'color-red',
      ]"
    >
      {{ item.description }}
      {{ item.abbreviation }}
    </p>
    <p class="mb-1 worksansr text-twelve upper-text">
      CADASTRADO POR: {{ item.user_name }}
    </p>
    <hr />
  </div>
</template>

<script>
export default {
  name: "FrequenciaRespiratoria",
  props: {
    care_vital_sign: Object,
    item: Object,
  },
};
</script>